import React from 'react';
import { Section } from '../ui/Section';
import { motion } from 'framer-motion';
export function PainPoints() {
  const points = ['Querés generar dinero… Pero nadie te enseñó cómo hacerlo de verdad.', 'Pasás horas mirando contenido… Pero no ejecutás.', 'Intentás… Pero no sabés por dónde empezar.', 'Y volvés siempre al mismo lugar.'];
  return <Section className="bg-dark-800 relative" data-id="element-153">
      <div className="absolute top-0 right-0 w-1/2 h-full bg-red-900/5 blur-[150px] pointer-events-none" data-id="element-154" />

      <div className="max-w-4xl mx-auto text-center" data-id="element-155">
        <h2 className="text-4xl md:text-5xl font-black text-white mb-16 leading-tight" data-id="element-156">
          <span className="text-red-500" data-id="element-157">❗</span> ¿CUÁNTOS DÍAS MÁS VAS A
          SEGUIR IGUAL?
        </h2>

        <div className="space-y-6" data-id="element-158">
          {points.map((point, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.15
        }} className="bg-dark-900/80 border border-dark-700 p-6 rounded-xl text-xl md:text-2xl text-gray-300 font-medium" data-id="element-159">
              {point}
            </motion.div>)}
        </div>
      </div>
    </Section>;
}